import BaseBehavior from '../../../framework/base/base';
import { animate } from '../../../shared/utilities/animate';

export function getAncestorAnchor(rootElm, maxDepth = 5) {
	let depth = 0;
	let elm = rootElm;
	while (elm && elm.nodeType === 1 && depth < maxDepth) {
		if (
			elm.matches('a') &&
			elm.hash !== '' &&
			(elm.getAttribute('href').indexOf(window.location.pathname) > -1 ||
				elm.getAttribute('href').indexOf('#') === 0) // checking if the url is for same page or different one and has a valid hash value
		) {
			return elm;
		}

		elm = elm.closest('a');
		depth++;
	}

	return null;
}

export function AnchorDispatcher() {
	const listeners = [];
	this.addListener = listener => {
		listeners.push(listener);
	};

	document.addEventListener('click', evt => {
		const anchor = getAncestorAnchor(evt.target);
		anchor && listeners.forEach(c => c(evt, anchor));
	});
}

let anchorDispatcher = null;

export function getAnchorDispatcher() {
	if (anchorDispatcher) {
		return anchorDispatcher;
	}

	anchorDispatcher = new AnchorDispatcher();
	return anchorDispatcher;
}

function getTopPositionFromBody(element) {
	let { offsetParent: parent, offsetTop: pos } = element;

	while (parent && parent.tagName.toLowerCase() !== 'body') {
		pos += parent.offsetTop;
		parent = parent.offsetParent;
	}
	if (element.parentElement?.classList.contains('glossary__details')) {
		const { offsetHeight } = element.parentElement.querySelector('.glossary__details-item-header');
		pos -= offsetHeight;
	}
	return pos;
}

function calculateEndPos(element) {
	const navTop = document.querySelector('.header') || { offsetHeight: 0 };
	const navRoot = document.querySelector('.v2-nav__root') || { offsetHeight: 0 };
	const cookieConsent = document.querySelector('.v2-cookie-disclaimer--top') || { offsetHeight: 0 };
	const startPos = window.pageYOffset;
	const endPos = getTopPositionFromBody(element);
	// In case of scroll down mega nav get's unpinned so anchor-link top position should be adjusted
	// anchor-link has a negative value for top
	if (endPos < startPos) {
		return endPos - (navRoot.offsetHeight + navTop.offsetHeight + cookieConsent.offsetHeight);
	}

	return endPos - (navTop.offsetHeight + cookieConsent.offsetHeight);
}

export function smoothScrollTo(element) {
	const startPos = window.pageYOffset;
	const endPos = calculateEndPos(element);
	const accordionCheck = element.nextElementSibling.querySelector('.v2-accordion [type=checkbox]');
	if (accordionCheck) {
		accordionCheck.checked = true;
	}
	animate(percentDone => {
		const easeInFactor = (Math.cos(Math.PI * (1 - percentDone)) + 1) / 2;
		const scrollOffset = (endPos - startPos) * easeInFactor;
		window.scroll(0, startPos + scrollOffset);
	}, 500);
}

export default class AnchorLink extends BaseBehavior {
	constructor(element) {
		super(element);
		const id = element.getAttribute('id');
		// check if URL contains #link, if exists call smotthScrollTo function for that Id
		window.addEventListener('load', this.init.bind(this));

		window.addEventListener(
			'hashchange',
			() => {
				if (window.location.hash) {
					this.scrollToHashlinkSec();
				}
			},
			false
		);

		getAnchorDispatcher().addListener((evt, anchor) => {
			if (
				(anchor.getAttribute('href').indexOf(window.location.pathname) > -1 &&
					anchor.getAttribute('href').indexOf(`#${id}`) > -1) ||
				anchor.getAttribute('href').indexOf(`#${id}`) === 0
			) {
				evt.preventDefault();
				smoothScrollTo(element);
			}
		});
	}

	init() {
		// check if URL contains #link, if exists call smotthScrollTo function for that Id
		if (window.location.hash) {
			this.scrollToHashlinkSec();
		}
	}

	scrollToHashlinkSec() {
		if (window.location.hash) {
			if (window.history.scrollRestoration) {
				window.history.scrollRestoration = 'manual';
			}
		}
		// Locate anchor via name attribute to avoid invalid id selector errors.
		const linkSelector = `[name='${window.location.hash.replace('#', '')}']`;
		const endPosElement = document.querySelector(linkSelector);
		// don't scroll when there is no corresponding anchor link to scroll to.
		if (endPosElement) {
			const endPos = calculateEndPos(endPosElement);
			// scroll with animation or not based on loading document visibiltiy.
			document.hidden === true ? window.scroll(0, endPos) : smoothScrollTo(endPosElement);
		}
	}
}
